// extracted by css-extract-rspack-plugin
export default {"settingsContainer":"Settings_settingsContainer__T72UX"};